// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getAlliedUniversityChildren from "@awc/App/Handlers/Content/getAlliedUniversityChildren";
import { CustomAppState } from "@awc/App/Store/Reducers";
import Zone from "@insite/client-framework/Components/Zone";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { MetaDescription, MetaKeywords } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    overrideTitle = "overrideTitle",
}
interface OwnProps extends PageProps {
    fields: {
        [fields.overrideTitle]: string;
    };
}

const mapStateToProps = (state: CustomAppState) => {
    const parentId = getPageLinkByPageType(state, "AlliedUniversityPage")?.id || "";
    return {
        parentId,
        isLoading: state.xPagesContent[parentId]?.isLoading,
        data: state.xPagesContent[parentId]?.data,
    };
};
const mapDispatchToProps = {
    getAlliedUniversityChildren,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const AlliedUniversityPage = ({ id, getAlliedUniversityChildren, data, isLoading, parentId }: Props) => {
    useEffect(() => {
        if (!data && !isLoading) {
            getAlliedUniversityChildren({ parentId });
        }
    }, []);
    return (
        <Page>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AlliedUniversityPage),
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            {
                name: fields.overrideTitle,
                displayName: "Page Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: true,
            },
            MetaKeywords,
            MetaDescription,
        ],
    },
};

export default pageModule;
export const AlliedUniversityPageContext = "AlliedUniversityPage";
